'use es6';

import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { fetchSubmissionAlertRequest, fetchSubmissionAlertResponse } from 'FormsUI/actions/alertActions';
const submissionReports = combineReducers({
  requested: handleActions({
    [fetchSubmissionAlertRequest]: () => true,
    [fetchSubmissionAlertResponse]: () => false
  }, false),
  value: handleActions({
    [fetchSubmissionAlertResponse]: (__, {
      payload: {
        alert = null
      } = {}
    }) => alert
  }, null),
  error: handleActions({
    [fetchSubmissionAlertRequest]: () => false,
    [fetchSubmissionAlertResponse]: {
      next() {
        return false;
      },
      throw() {
        return true;
      }
    }
  }, false)
});
export default combineReducers({
  submissionReports
});